// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "mainSite." + chunkId + "." + "fa8af68fa090ae2e1719" + ".css";
};